export default __webpack_public_path__ + "images/E2.27b6cba.png";